export default "__VITE_ASSET__DCo$_Ffu__"